module.exports = __webpack_public_path__ + "img/exportTXTWhite.ed086086.svg";